import React, { useState } from "react";
import '../../Accounts/Accounts.css';
import { Modal, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { submitDeliveryExcellenceRequest } from "../../../../store/features/actions/deliveryExcellenceActions";
import CircularLoader from "../../../HtmlElements/CircularLoader";

const DeliveryExcellenceModal = ({ show, onClose, clientName, accountName }) => {
    const dispatch = useDispatch();
    const { loading, errorMessage } = useSelector(state => state.deliveryExcellenceReducer);
    const [context, setContext] = useState("");
    const [error, setError] = useState("");
  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (!context.trim()) {
        setError("Context is required.");
        return;
      }
      dispatch(submitDeliveryExcellenceRequest({
        formData: {
          clientName,
          accountName,
          context,
          response_type: "pdf"
        }
      }));
      setContext("");
      setError("");
      onClose();
    };
  
    return (
      loading ? (
        <div 
          className="pt-4"
          style={{
            position: 'fixed',
            top: '16px',
            right: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '12px',
            zIndex: 9999,
            pointerEvents: 'none', // so background stays clickable
          }}
        >
          <CircularLoader />
        </div>) : (<Modal size="lg" show={show} onHide={onClose} centered>
        <Modal.Body>
          <div className="recent_dev_wrapper">
            <div className="recent_dev_block">
              <div className="recent_icon_head">
                <div className="recent_head_block">
                  <h3 className="recent_head">Delivery Excellence</h3>
                </div>
                <Modal.Header closeButton style={{ borderBottom: 0 }} />
              </div>
              <div className="para_block">
                <Form onSubmit={handleSubmit}>
                  <div className="col-md-12">
                    <Form.Group className="mb-3 custom_agentform_group">
                      <Form.Label className="custom_agentform_label">
                        Provide additional context <span className="red">*</span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        className="contextArea"
                        placeholder="Include deal specifics and any additional context here"
                        rows={3}
                        value={context}
                        disabled={loading}
                        onChange={(e) => {
                          const value = e.target.value;
                          setContext(value);
                          setError(value.trim() === "" ? "Context is required" : "");
                        }}
                      />
                      {error && <p className="text-danger">{error}</p>}
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <div className="prev_next_block">
                      <button
                        type="submit"
                        className="genrate_modal_btn btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Generate"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary cancel_modal_btn ml-2"
                        disabled={loading}
                        onClick={() => {
                          setContext("");
                          setError("");
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                  {errorMessage && (
                    <p className="text-danger">{errorMessage}</p>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>)
    );
  };
  
  export default DeliveryExcellenceModal;  